import { useTranslation } from 'react-i18next';

const trustImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20close-up%20of%20dental%20implant%20surgery%20procedure%20with%20gloved%20hands%20using%20precision%20dental%20tools%20on%20a%20patient%20in%20a%20modern%20dental%20clinic%2C%20bright%20clinical%20overhead%20lighting%2C%20clean%20white%20dental%20environment%2C%20sterile%20blue%20drapes%2C%20professional%20medical%20photography%2C%20sharp%20focus%20on%20dental%20instruments%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-dental-surgery-01&orientation=landscape',
    alt: 'Dental implant surgery procedure',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20detailed%20dental%20implant%20model%20on%20a%20white%20surface%20in%20a%20modern%20dental%20laboratory%2C%20showing%20realistic%20ceramic%20crowns%20and%20titanium%20implants%20with%20gum%20tissue%20simulation%2C%20soft%20clinical%20lighting%2C%20clean%20white%20background%2C%20professional%20dental%20photography%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-dental-01&orientation=landscape',
    alt: 'Dental implant model',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20close-up%20of%20another%20dental%20implant%20model%20showing%20upper%20jaw%20with%20zirconia%20crowns%20and%20abutments%20on%20a%20light%20wooden%20surface%2C%20clinical%20dental%20setting%20with%20soft%20natural%20light%2C%20white%20and%20cream%20tones%2C%20high%20detail%20product%20photography%20style%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-dental-02&orientation=landscape',
    alt: 'Dental model zirconia crowns',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Close-up%20beauty%20shot%20of%20a%20perfect%20white%20smile%20with%20flawless%20veneers%20on%20a%20woman%20with%20glowing%20healthy%20skin%2C%20soft%20warm%20studio%20lighting%20from%20above%2C%20neutral%20beige%20background%2C%20professional%20dental%20cosmetics%20photography%2C%20natural%20and%20radiant%20expression%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-smile-01&orientation=landscape',
    alt: 'Perfect smile with veneers',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20dental%20laboratory%20technician%20working%20on%20a%20dental%20prosthesis%20with%20precision%20tools%20in%20a%20clean%20modern%20dental%20lab%2C%20focused%20hands%20crafting%20a%20ceramic%20crown%2C%20bright%20clean%20workspace%20with%20dental%20equipment%2C%20white%20and%20light%20gray%20environment%2C%20professional%20dental%20craftsmanship%20photography%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-dental-lab-01&orientation=landscape',
    alt: 'Dental lab technician crafting prosthesis',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20smile%20of%20a%20female%20dentist%20in%20a%20modern%20bright%20dental%20clinic%20consultation%20room%2C%20wearing%20clean%20white%20medical%20coat%2C%20gentle%20professional%20demeanor%2C%20natural%20daylight%20from%20window%2C%20white%20and%20warm%20beige%20interior%2C%20patient%20trust%20building%20moment%2C%20professional%20headshot%20style%20dental%20photography%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=500&seq=trust-dental-consult-01&orientation=landscape',
    alt: 'Dentist consultation',
  },
];

const checkItems = [
  'trust.check1',
  'trust.check2',
  'trust.check3',
  'trust.check4',
  'trust.check5',
  'trust.check6',
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 lg:py-28 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Left: Text content */}
          <div className="flex-1 lg:max-w-md">
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              <span className="block">{t('trust.heading_line1')}</span>
              <span className="block mt-1">
                {t('trust.heading_line2')}
              </span>
            </h2>

            <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-500 font-body leading-relaxed">
              {t('trust.subtitle')}
            </p>

            <ul className="mt-6 md:mt-8 space-y-3 md:space-y-3.5">
              {checkItems.map((key) => (
                <li
                  key={key}
                  className="flex items-start gap-3 text-sm md:text-base text-foreground-700 font-body leading-snug"
                >
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                  </span>
                  <span>{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: 3x2 image grid */}
          <div className="flex-1 w-full">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {trustImages.map((img, idx) => (
                <div
                  key={idx}
                  className="relative rounded-xl overflow-hidden aspect-[4/3] group"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}